<mat-sidenav-container class="sidenav-container" *ngIf="!hideMenu">
  <mat-sidenav
    #drawer
    class="sidenav"
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
    [fixedInViewport]="true"
    [attr.role]="'navigation'"
    [disableClose]="!isMobile"
  >
    <div class="sidenav-top">
      <div class="sidenav-brand">
        <img
          [src]="logoLight"
          alt="Logo"
          class="sidenav-brand__logo theme-logo theme-logo--light"
        />
        <img
          [src]="logoDark"
          alt=""
          class="sidenav-brand__logo theme-logo theme-logo--dark"
          aria-hidden="true"
        />
      </div>

      <div class="menu-avatar">
      <button
        mat-icon-button
        type="button"
        class="sidenav-close"
        *ngIf="isMobile"
        (click)="drawer.close()"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
      <img class="avatar-img" alt="Avatar" [src]="appUser?.thumbnailPhotoUrl ?? ''" *ngIf="appUser?.thumbnailPhotoUrl" />
      <h4 class="name">{{ (user | async)?.displayName }}</h4>
      <div class="email">{{ (user | async)?.email }}</div>
      <span class="current-domain">{{ (account$ | async) }}</span>
    </div>
    </div>

    <div class="sidenav-scroll">
    <div class="subscription-upgrade-container" *ngIf="auth.hasCompanyManagerAccess && (appUser?.planId === 'free' || appUser?.planId === 'freemium')">
      <a class="subscription-upgrade-link" [routerLink]="['/subscription']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
        <div class="upgrade-content">
          <mat-icon class="upgrade-icon">upgrade</mat-icon>
          <span class="upgrade-text">{{ 'menu.upgradeSubscription' | translate }}</span>
        </div>
      </a>
    </div>

    <app-trial-info />

    <mat-accordion class="navigation-accordion" multi="true">
      <mat-expansion-panel class="start-panel" [disabled]="true" (click)="goToStart()"
                           [class.active]="router.url === '/start'" *ngIf="auth.hasCompanyManagerAccess">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>star</mat-icon>
            {{ 'menu.start' | translate }}
            <div class="start-progress-mini" *ngIf="!(appUser?.planId && appUser?.planId !== 'free' && appUser?.planId !== 'freemium' && startProgress === 100)">
              <div class="progress-bar-mini">
                <div class="progress-fill-mini" [style.width.%]="startProgress"></div>
              </div>
              <span class="progress-text-mini">{{ startProgress }}%</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <mat-expansion-panel #digitalCardsPanel [expanded]="digitalCardsPanelExpanded" *ngIf="showDigitalCardsNav">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>badge</mat-icon>
            {{ 'menu.cardDigital' | translate }}
            <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(digitalCardEnabled)">{{ 'menu.inactive' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/digital-cards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidenavOnMobile()" *ngIf="auth.isSuperAdmin || auth.hasCompanyManagerAccess">
              <mat-icon matListItemIcon>mail</mat-icon>
              <div matListItemTitle>{{ 'digitalCards.templatesMenu' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/digital-cards/statistics']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="auth.isSuperAdmin || auth.hasCompanyManagerAccess">
              <mat-icon matListItemIcon>query_stats</mat-icon>
              <div matListItemTitle>{{ 'digitalCards.statistics' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/digital-cards/sources']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="showContextualQrNav">
              <mat-icon matListItemIcon>campaign</mat-icon>
              <div matListItemTitle>
                {{ 'digitalCards.sources.menu' | translate }}
                <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(contextualQrEnabled)">{{ 'menu.inactive' | translate }}</span>
              </div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/print-cards']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidenavOnMobile()" *ngIf="showSelfPrintCardsNav">
              <mat-icon matListItemIcon>print</mat-icon>
              <div matListItemTitle>
                {{ 'printCards.menu' | translate }}
                <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(selfPrintCardsEnabled)">{{ 'menu.inactive' | translate }}</span>
              </div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/card-orders']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidenavOnMobile()" *ngIf="showCardOrdersNav">
              <mat-icon matListItemIcon>shopping_bag</mat-icon>
              <div matListItemTitle>
                {{ 'cardOrders.menu' | translate }}
                <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(selfPrintCardsEnabled)">{{ 'menu.inactive' | translate }}</span>
              </div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel #signaturesPanel [expanded]="signaturesPanelExpanded" *ngIf="showSignaturesNav">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>edit_note</mat-icon>
            {{ 'menu.footersSection' | translate }}
            <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(emailSignaturesEnabled)">{{ 'menu.inactive' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/signatures/custom']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>email</mat-icon>
              <div matListItemTitle>{{ 'menu.configurator' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item (click)="redirectToGenerator(); closeSidenavOnMobile()">
              <mat-icon matListItemIcon>construction</mat-icon>
              <div matListItemTitle>{{ 'menu.generator' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/planned']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>timelapse</mat-icon>
              <div matListItemTitle>{{ 'menu.planned' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/stats']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>query_stats</mat-icon>
              <div matListItemTitle>{{ 'menu.analytics' | translate }}</div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel #backgroundsPanel [expanded]="backgroundsPanelExpanded"
        *ngIf="showBackgroundsNav">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>image</mat-icon>
            {{ 'digitalCards.backgroundTab' | translate }}
            <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(virtualBackgroundsEnabled)">{{ 'menu.inactive' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/backgrounds']" [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>videocam</mat-icon>
              <div matListItemTitle>{{ 'menu.backgroundTemplates' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/backgrounds/meets']" [routerLinkActive]="'active'"
              (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>groups</mat-icon>
              <div matListItemTitle>{{ 'meetBackground.title' | translate }}</div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel #settingsPanel [expanded]="settingsPanelExpanded"
        *ngIf="auth.hasCompanyManagerAccess">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>settings</mat-icon>
            {{ 'menu.settings' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/user-admins']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>stars</mat-icon>
              <div matListItemTitle>{{ 'menu.admins' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/domains']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>domain</mat-icon>
              <div matListItemTitle>{{ 'menu.domains' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/employees']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="auth.hasCompanyManagerAccess">
              <mat-icon matListItemIcon>contact_mail</mat-icon>
              <div matListItemTitle>{{ 'menu.employees' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/addons']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="auth.hasCompanyManagerAccess">
              <mat-icon matListItemIcon>add_box</mat-icon>
              <div matListItemTitle>{{ 'menu.addons' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/media']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="auth.hasCompanyManagerAccess">
              <mat-icon matListItemIcon>perm_media</mat-icon>
              <div matListItemTitle>{{ 'menu.media' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/company']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>corporate_fare</mat-icon>
              <div matListItemTitle>{{ 'menu.companyData' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/employees']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>group</mat-icon>
              <div matListItemTitle>{{ 'menu.employeeData' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/departments']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>business</mat-icon>
              <div matListItemTitle>{{ 'menu.branch' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/advanced']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>build</mat-icon>
              <div matListItemTitle>{{ 'menu.advanced' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/extension']" routerLinkActive="active" (click)="closeSidenavOnMobile()" *ngIf="showBrowserExtensionNav">
              <mat-icon matListItemIcon>extension</mat-icon>
              <div matListItemTitle>
                {{ 'menu.extension' | translate }}
                <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(browserExtensionEnabled)">{{ 'menu.inactive' | translate }}</span>
              </div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/integration']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>link</mat-icon>
              <div matListItemTitle>{{ 'menu.integration' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/api']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>api</mat-icon>
              <div matListItemTitle>{{ 'menu.restApi' | translate }}</div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel #billingPanel [expanded]="billingPanelExpanded" *ngIf="auth.hasCompanyManagerAccess && !auth.appUser?.subdomain">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>receipt_long</mat-icon>
            {{ 'menu.settlements' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/settings/billing']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>payment</mat-icon>
              <div matListItemTitle>{{ 'menu.payments' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/subscription']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>subscriptions</mat-icon>
              <div matListItemTitle>{{ 'menu.plans' | translate }}</div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel #myProfilePanel [expanded]="myProfilePanelExpanded">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>person</mat-icon>
            {{ 'menu.myProfile' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/my-account']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="auth.hasEmployee">
              <mat-icon matListItemIcon>account_circle</mat-icon>
              <div matListItemTitle>{{ 'menu.myAccount' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/my-digital-cards']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="showMyDigitalCardsNav">
              <mat-icon matListItemIcon>badge</mat-icon>
              <div matListItemTitle>
                {{ 'menu.myDigitalCards' | translate }}
                <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(digitalCardEnabled)">{{ 'menu.inactive' | translate }}</span>
              </div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/my-backgrounds']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()" *ngIf="showMyBackgroundsNav">
              <mat-icon matListItemIcon>image</mat-icon>
              <div matListItemTitle>
                {{ 'menu.myBackgrounds' | translate }}
                <span class="dbc1-inactive-tag" *ngIf="isOptionalNavInactive(virtualBackgroundsEnabled)">{{ 'menu.inactive' | translate }}</span>
              </div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/accounts']" [routerLinkActive]="'active'" *ngIf="auth.hasEmployee && auth.hasCompanyManagerAccess && auth.canChangeAccounts" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>supervisor_account</mat-icon>
              <div matListItemTitle>{{ 'menu.changeAccount' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item (click)="auth.logOut(); closeSidenavOnMobile()" [routerLinkActive]="'active'">
              <mat-icon matListItemIcon>exit_to_app</mat-icon>
              <div matListItemTitle>{{ 'menu.logout' | translate }}</div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel #adminPanel [expanded]="adminPanelExpanded" *ngIf="auth.isSuperAdmin">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon matListItemIcon>admin_panel_settings</mat-icon>
            {{ 'menu.administration' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <mat-nav-list>
            <a class="nav-link" mat-list-item [routerLink]="['/admin/audit-log']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>history</mat-icon>
              <div matListItemTitle>{{ 'menu.auditLog' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/admin/print-card-orders']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>local_shipping</mat-icon>
              <div matListItemTitle>{{ 'menu.printCardOrders' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/admin/client']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>person_pin_circle</mat-icon>
              <div matListItemTitle>{{ 'menu.clients' | translate }}</div>
            </a>
            <a class="nav-link" mat-list-item [routerLink]="['/admin/reseller']" [routerLinkActive]="'active'" (click)="closeSidenavOnMobile()">
              <mat-icon matListItemIcon>sell</mat-icon>
              <div matListItemTitle>{{ 'menu.reseller' | translate }}</div>
            </a>
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
    </div>

    <div class="sidenav-bottom">
    <div class="language-selector">
      <button
        mat-icon-button
        type="button"
        class="theme-toggle"
        (click)="theme.toggleTheme()"
        [attr.aria-label]="theme.isDark ? 'Light mode' : 'Dark mode'"
      >
        <mat-icon>{{ theme.isDark ? "dark_mode" : "light_mode" }}</mat-icon>
      </button>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="language-select">
        <mat-select [value]="selectedLanguage" (selectionChange)="change($event)" aria-label="Language">
          <mat-option *ngFor="let language of languages" [value]="language">{{ language.toUpperCase() }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content" [class.sidenav-content--mobile]="isMobile">
    <mat-toolbar class="mobile-toolbar" *ngIf="isMobile">
      <button
        mat-icon-button
        type="button"
        (click)="drawer.toggle()"
        class="menu-button-mobile"
        aria-label="Menu"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <img
        [src]="logoLight"
        alt="Logo"
        class="mobile-toolbar__logo theme-logo theme-logo--light"
      />
      <img
        [src]="logoDark"
        alt=""
        class="mobile-toolbar__logo theme-logo theme-logo--dark"
        aria-hidden="true"
      />
    </mat-toolbar>

    <app-signature-installation-progress-toast />

    <div class="main-content">
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<div *ngIf="hideMenu">
  <app-signature-installation-progress-toast />

  <div class="main-content">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
